import { render, staticRenderFns } from "./Form20Table.vue?vue&type=template&id=48f7990d"
import script from "./Form20Table.vue?vue&type=script&lang=ts"
export * from "./Form20Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports